function tabs(){
    const tabsLinks = document.querySelector('.tabs__links');

    if(tabsLinks){
        tabsLinks.addEventListener('click', function(e) {
            e.preventDefault();

            if (e.target.classList.contains('tabs__link')) {
                const tabsLink = e.target,
                    tabs__contents = tabsLink.closest('.tabs').querySelectorAll('.tabs__content'),
                    itemPosition = [...tabsLink.parentNode.children].indexOf(tabsLink);

                tabs__contents.forEach((tabsContent, index) => {
                    tabsContent.classList.toggle('tabs__content_active', index === itemPosition);
                });

                tabsLink.classList.toggle('tabs__link_active', true);
                [...tabsLink.parentNode.children].filter(child => child !== tabsLink).forEach(sibling => sibling.classList.remove('tabs__link_active'));
            }
        });

        // first tab active
        document.querySelector('.tabs__link').classList.add('tabs__link_active');
        document.querySelector('.tabs__content').classList.add('tabs__content_active');
    }

    // open tab on url id
    const urlTabIdIndex = window.location.href.indexOf('#');
    if (urlTabIdIndex !== -1) {
        const tabId = window.location.href.substring(urlTabIdIndex + 1);
        openTab(tabId);
    }

    function openTab(tabName) {
        const tabsLinks = document.querySelectorAll('.tabs__link');
        const tabsContents = document.querySelectorAll('.tabs__content');

        tabsLinks.forEach(tabsLink => {
            if (tabsLink.getAttribute('id') === tabName) {
                tabsLink.classList.add('tabs__link_active');
            } else {
                tabsLink.classList.remove('tabs__link_active');
            }
        });

        tabsContents.forEach((tabsContent, index) => {
            if (index === Array.from(tabsLinks).findIndex(tabsLink => tabsLink.getAttribute('id') === tabName)) {
                tabsContent.classList.add('tabs__content_active');
            } else {
                tabsContent.classList.remove('tabs__content_active');
            }
        });
    }

    // open tab on link
    const linksTabs = document.querySelector('.product__links-tab');
    if(linksTabs) {
        linksTabs.addEventListener('click', function(e) {
            if (e.target.classList.contains('product__links-tab__item')) {
                e.preventDefault();
                const tabName = e.target.getAttribute('href').replace('#', '');
                openTab(tabName);
            }
        });
    }
}

export default tabs;